import "../styles.css";
import { useNotes } from "../context";
import dayjs from "dayjs";
import { BsPin } from "react-icons/bs";
import { MdPushPin } from "react-icons/md";
import { Toaster } from "react-hot-toast";

export default function AddNote() {
  const { state, dispatch, updateNoteHandler } = useNotes();

  const formatDate = () => dayjs().format("YYYY-MM-DD");
  const formatTime = () => dayjs().format("HH:mm:ss");

  return (
    <div className="AddNote flex-col">
      <div className="add-note-container">
        <section className="note-title-container tags-input">
          <input
            name="notetittle"
            placeholder="Note Tittle"
            className="note-textarea"
            maxLength="50"
            value={state.title}
            onChange={(e) =>
              dispatch({ type: "SET_TITLE", payload: e.target.value })
            }
          />
        </section>
        <section className="note-body-container tags-input">
          <textarea
            name="notebody"
            placeholder="Enter Note in 250 letters"
            className="note-textarea"
            maxLength="250"
            value={state.content}
            onChange={(e) =>
              dispatch({ type: "SET_CONTENT", payload: e.target.value })
            }
          />
        </section>
        <section className="note-tags-container tags-input">
          <ul id="tags">
            {state.tags.map((tag, index) => (
              <li key={index} className="tag">
                <span className="tag-title">{tag}</span>
                <span
                  className="tag-close-icon"
                  onClick={() =>
                    dispatch({ type: "REMOVE_TAGS", payload: index })
                  }
                >
                  x
                </span>
              </li>
            ))}
          </ul>
          <input
            type="text"
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                if (e.target.value !== "") {
                  dispatch({ type: "ADD_TAGS", payload: e.target.value });
                  e.target.value = "";
                }
              }
            }}
            placeholder="Press enter to add tags"
          />
        </section>
        <section className="note-timer-container ">
          <label htmlFor="Timer" className="bold">
            Time :{" "}
          </label>
          <select
            name="Timer"
            id="Timer"
            className="p1"
            value={state.timer}
            onChange={(e) =>
              dispatch({
                type: "SET_NOTE",
                value: e.target.value,
                key: "timer",
              })
            }
          >
            <option defaultValue>Select a Timer</option>
            <option value="5">5 min</option>
            <option value="10">10 min</option>
            <option value="15">15 min</option>
            <option value="20">20 min</option>
            <option value="25">25 min</option>
            <option value="30">30 min</option>
            <option value="35">35 min</option>
            <option value="40">40 min</option>
            <option value="45">45 min</option>
            <option value="50">50 min</option>
            <option value="55">55 min</option>
            <option value="60">60 min</option>
          </select>
        </section>
        <br />

        <ul className="note-label-container list p1 bold">
          {state.pin ? (
            <li>
              <MdPushPin
                name="pin item"
                className="p3 text-grey ptr"
                title="pinned note"
                onClick={() => {
                  dispatch({ type: "SET_PIN", payload: !state.pin });
                }}
              />
              <p>Unpin Note</p>
            </li>
          ) : (
            <li>
              <BsPin
                name="pin item"
                className="p3 text-grey ptr"
                title="unpined note"
                onClick={() => {
                  dispatch({ type: "SET_PIN", payload: !state.pin });
                }}
              />
              <p>Pin Note</p>
            </li>
          )}
        </ul>
        <button
          className="button button-primary bold ptr"
          style={{
            visibility:
              state.title &&
              state.title.length > 0 &&
              state.timer !== "Select a Timer"
                ? "visible"
                : "hidden",
          }}
          onClick={() => {
            dispatch({ type: "SET_DATE", payload: formatDate });
            dispatch({ type: "SET_DATE_TIME", payload: formatTime });
            updateNoteHandler(state, state._id);
            dispatch({ type: "CLEAR_NOTE" });
          }}
        >
          Update
        </button>
      </div>
      <Toaster position="bottom-right" reverseOrder={true} />
    </div>
  );
}
